/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ShareNetworkIcon16Solid = forwardRef('ShareNetworkIcon16Solid', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M11 6.75a2.75 2.75 0 1 0-2.698-2.216L5.829 5.947a2.75 2.75 0 1 0 0 4.106l2.473 1.413a2.75 2.75 0 1 0 .869-1.52L6.697 8.535a2.764 2.764 0 0 0 0-1.068l2.473-1.413A2.74 2.74 0 0 0 11 6.75Z" })));
});
